<template>
  <div class="m-card">
    <div style="display: flex; justify-content: space-around">
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1em;
        "
      >
        <div style="font-weight: bold; color: #32c040">Floor 9 Zone 1</div>
        <div style="font-weight: bold">Total Worker Active</div>
        <div style="font-weight: bold; font-size: 3em">{{gateway1.length}} / {{listTag.length}}</div>
        <div
          style="
            background-color: #32c040;
            padding: 0.2rem 0.5rem;
            border-radius: 0.3rem;
            color: #fff;
          "
        >
          PEOPLE
        </div>
      </div>
      <div style="position: relative; width: 60%">
        <img
          src="@/assets/images/xtple/map2.png"
          alt="map"
          style="width: 100%"
        />
        <div>
        <img
          src="@/assets/images/icon/wifi.gif"
          alt="gateway"
          style="
            position: absolute;
            top: 46%;
            left: 26%;
            width: 3em;
            transform: translate(-50%, -100%);
          "
        />
        <img
          src="@/assets/images/icon/wifi.gif"
          alt="gateway"
          style="
            position: absolute;
            top: 39%;
            left: 67%;
            width: 3em;
            transform: translate(-50%, -100%);
          "
        />
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1em;
        "
      >
        <div style="font-weight: bold; color: #58bdff">Floor 8 Zone 2</div>
        <div style="font-weight: bold">Total Worker Active</div>
        <div style="font-weight: bold; font-size: 3em">{{gateway2.length}} / {{listTag.length}}</div>
        <div
          style="
            background-color: #58bdff;
            padding: 0.2rem 0.5rem;
            border-radius: 0.3rem;
            color: #fff;
          "
        >
          PEOPLE
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    listTag:[Array,Object],
    gateway1:[Array,Object],
    gateway2:[Array,Object],

  }
};
</script>

<style>
</style>